import { cva } from "components/lib";

const Variants = cva(
  `inline-flex items-center rounded-[6px] bg-opacity-20 border px-2 py-1 
   text-xs font-bold transition-colors focus:outline-none 
   focus:ring-2 focus:ring-ring focus:ring-offset-2`,

  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-white",
        outline: "text-foreground",
        red: "border-red-500/30 bg-red-500/20 text-red-400 font-medium",
        blue: "border-blue-500/30 bg-blue-500/20 text-blue-400 font-medium",
        green: "border-green-500/30 bg-green-500/20 text-green-400 font-medium",
        orange: "border-transparent bg-orange-500 text-orange-500",
        brown: "border-transparent bg-[#B76E00] text-[#B71D18]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export default Variants;
